import {
  DEAL_PROMPT_US_REGION_CODE,
  type DealPromptFilters,
  dealPromptFilterDevice,
  dealPromptFilterFormats,
  dealPromptFilterSegmentSearchMode,
} from '../types.ts';

const TV_IDS = new Set<string>(['tv_devices', dealPromptFilterDevice.CONNECTED_TV, dealPromptFilterDevice.SET_TOP_BOX]);

const stripTvDevices = (devices: string[]) => devices.filter(id => !TV_IDS.has(id));

const isUsRegion = (region: DealPromptFilters['region']) => !region || region === DEAL_PROMPT_US_REGION_CODE;

export const sanitizeDealPromptFormatAndDevices = (
  filters: DealPromptFilters,
  previousFilters?: DealPromptFilters
): DealPromptFilters => {
  let adjusted: DealPromptFilters = filters;

  if (
    previousFilters !== undefined &&
    previousFilters.segment_search_mode !== adjusted.segment_search_mode &&
    adjusted.account !== undefined
  ) {
    const { account: _accountFromModeChange, ...rest } = adjusted;
    adjusted = rest;
  }

  if (previousFilters !== undefined && isUsRegion(previousFilters.region) !== isUsRegion(adjusted.region)) {
    if (isUsRegion(adjusted.region)) {
      const { country: _country, ...rest } = adjusted;
      adjusted = rest;
    } else {
      const { state: _state, dma: _dma, congressionalDistrict: _congressionalDistrict, ...rest } = adjusted;
      adjusted = rest;
    }
  }

  if (
    !isUsRegion(adjusted.region) &&
    (adjusted.age !== undefined || adjusted.gender !== undefined || adjusted.demographic !== undefined)
  ) {
    const { age: _age, gender: _gender, demographic: _demographic, ...rest } = adjusted;
    adjusted = rest;
  }

  const baseFilters: DealPromptFilters =
    adjusted.segment_search_mode === dealPromptFilterSegmentSearchMode.MY_DATA && adjusted.account !== undefined
      ? (() => {
          const { account: _account, ...rest } = adjusted;
          return rest;
        })()
      : adjusted;

  const next: DealPromptFilters = { ...baseFilters };

  const format = next.format;
  const devices = next.ds_device;

  const hasFormat = Array.isArray(format) && format.length > 0 && !!format[0];
  const hasDevices = Array.isArray(devices) && devices.length > 0;

  if (!hasFormat && hasDevices) {
    next.ds_device = undefined;
    return next;
  }

  if (Array.isArray(format) && format.length > 1) {
    next.format = [format[0]] as DealPromptFilters['format'];
  }

  if (hasFormat) {
    const selectedFormat = format![0];

    const shouldDisableTv =
      selectedFormat === dealPromptFilterFormats.BANNER || selectedFormat === dealPromptFilterFormats.NATIVE;

    if (shouldDisableTv && Array.isArray(devices) && devices.length > 0) {
      const cleaned = stripTvDevices(devices);
      next.ds_device = cleaned.length > 0 ? cleaned : undefined;
    }
  }

  return next;
};
